import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from '../ConfirmCancelDialog';
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniKustannuspaikka;

class KulutusEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            KustannuspaikkaAvain: data[0].kustannuspaikkaAvain,
            TapahtumaAika: dayjs(data[0].tapahtumaAika),
            Tuoteryhma: data[0].tuoteryhma,
            Tuotenimi: data[0].tuotenimi,
            Yritys: data[0].yritys,
            Selite: data[0].selite,
            Maara: data[0].maara,
            Euro: data[0].euro,
            CO2: data[0].cO2,
            KulutusTyyppi: data[0].kulutusTyyppi,
            Yksikko: data[0].yksikko,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            kulutukset: (Object.keys(props.lookupLists.kulutukset).map((d) => ({ value: d, label: props.lookupLists.kulutukset[d] })) || []),
            kustannuspaikat: (Object.keys(props.lookupLists.kustannuspaikat).map((d) => ({ value: d, label: props.lookupLists.kustannuspaikat[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniKustannuspaikka = this.state.kustannuspaikat.find(({ value }) => value === (this.state.KustannuspaikkaAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            KustannuspaikkaAvain: this.state.data[0].kustannuspaikkaAvain,
            TapahtumaAika: dayjs(this.state.data[0].tapahtumaAika),
            Tuoteryhma: this.state.data[0].tuoteryhma,
            Tuotenimi: this.state.data[0].tuotenimi,
            Yritys: this.state.data[0].yritys,
            Selite: this.state.data[0].selite,
            Maara: this.state.data[0].maara,
            Euro: this.state.data[0].euro,
            CO2: this.state.data[0].cO2,
            KulutusTyyppi: this.state.data[0].kulutusTyyppi,
            Yksikko: this.state.data[0].yksikko,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            KustannuspaikkaAvain: this.state.KustannuspaikkaAvain,
            TapahtumaAika: this.state.TapahtumaAika.format("MM/DD/YYYY 00:00:00"),
            Tuoteryhma: this.state.Tuoteryhma,
            Tuotenimi: this.state.Tuotenimi,
            Yritys: this.state.Yritys,
            Selite: this.state.Selite,
            Maara: (this.state.Maara || "").toString().replace(",", "."),
            Euro: (this.state.Euro || "").toString().replace(",", "."),
            CO2: (this.state.CO2 || "").toString().replace(",", "."),
            KulutusTyyppi: this.state.KulutusTyyppi,
            Yksikko: this.state.Yksikko,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, kulutukset, kustannuspaikat } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.DataIngestion.Kulutus.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniKustannuspaikka}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'KustannuspaikkaAvain')}
                                options={kustannuspaikat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="outlined" label={dictionary.DataIngestion.Kulutus.Columns[1]} />}
                            />
                        </Box>
                        <LocalizedDatePicker
                            label={dictionary.DataIngestion.Kulutus.Columns[2]}
                            value={this.state.TapahtumaAika}
                            onChange={(newValue) => this.handleChangeDate('TapahtumaAika', newValue)}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Tuoteryhma}
                            onChange={this.handleChange('Tuoteryhma')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Tuotenimi}
                            onChange={this.handleChange('Tuotenimi')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Yritys}
                            onChange={this.handleChange('Yritys')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Selite}
                            onChange={this.handleChange('Selite')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Maara}
                            onChange={this.handleChange('Maara')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.Euro}
                            onChange={this.handleChange('Euro')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.CO2}
                            onChange={this.handleChange('CO2')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.KulutusTyyppi}
                            onChange={this.handleChange('KulutusTyyppi')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Kulutus.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.Yksikko}
                            onChange={this.handleChange('Yksikko')}
                        />
                    </DialogContent>
                    {/* TODO:THEME */}
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "KulutusEdit" })(KulutusEdit);
